module.exports = __webpack_public_path__ + "static/media/housesauce.42b35606.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/flavor/housesauce.jpg
// module id = 146
// module chunks = 0